import { TwButton, TwButtonType } from '../../components/TwButtons/TwButtons';

import React from 'react';
import TwDialog from '../../components/TwDialog/TwDialog';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Box from '@mui/material/Box';
import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import {
  clearLtlTripsPayOverrideDataInOrder,
  updateShowRatesWarningLtl
} from '../../redux/features/orders/ordersSlice';
import Typography from '@mui/material/Typography';
import StringUtils from '../../utils/stringUtils';

interface TwLTLRatesWarningProps {
  open: boolean;
}

const TwLTLRatesWarning = ({ open }: TwLTLRatesWarningProps): JSX.Element => {
  const { ltl_trips_in_order, show_rates_warning_ltl } = useAppSelector((state) => state.orders);
  const dispatch = useAppDispatch();
  const handleCancel = (): void => {
    dispatch(updateShowRatesWarningLtl({ open: false, action: null }));
  };
  const handleProceed = (): void => {
    show_rates_warning_ltl.action && show_rates_warning_ltl.action();
    // we have to delete the driver pay override data for the ltl trips state so modal does not show again on every rate update
    dispatch(clearLtlTripsPayOverrideDataInOrder());
    dispatch(updateShowRatesWarningLtl({ open: false, action: null }));
  };
  return (
    <TwDialog
      open={open}
      title="Clear driver pay?"
      onClickClose={handleCancel}
      actions={[
        <TwButton key="1" type={TwButtonType.secondary} label="Cancel" action={handleCancel} />,
        <TwButton key="2" type={TwButtonType.primary} label="Confirm" action={handleProceed} />
      ]}
    >
      <>
        <div className="warning tid-warning__content">
          <Warning />
        </div>
        <Box>
          <Typography variant="body2" fontSize="14px" color="#6B7280">
            Updating a rate will lead to changing driver pay information on trip(s):
          </Typography>
          {ltl_trips_in_order.length > 0 && (
            <Box>
              {ltl_trips_in_order.map((trip) =>
                trip.selected_drivers.map((driver) => {
                  if (driver.driver_pay_override_data) {
                    return (
                      <Typography variant="body2" fontSize="14px" color="#6B7280" key={driver.id}>
                        <Typography component={'span'} fontSize="14px" fontWeight={'500'}>
                          • {StringUtils.addApostropheToString(driver.name || '')}
                        </Typography>{' '}
                        pay on{' '}
                        <Typography component={'span'} fontSize="14px" fontWeight={'500'}>
                          Trip {trip.readable_id}
                        </Typography>
                      </Typography>
                    );
                  }
                })
              )}
            </Box>
          )}
          <Typography variant="body2" fontSize="14px" color="#6B7280">
            {' '}
            Are you sure you want to update the rate?
          </Typography>
        </Box>
      </>
    </TwDialog>
  );
};

export default TwLTLRatesWarning;
